var React = require('react');

function NewHLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.0591 19.7672H18.4538L21.8884 0.23291H15.4919L14.2385 7.23008H8.68752L9.94091 0.23291H3.54791L0.113342 19.7672H6.50809L7.79649 12.4584H13.3475L12.0591 19.7672Z","fill":"white"}));
}

NewHLogo.defaultProps = {"width":"22","height":"20","viewBox":"0 0 22 20","fill":"none"};

module.exports = NewHLogo;

NewHLogo.default = NewHLogo;
